import { STINT_STATUS } from 'utils';

export const UNIVERSITY_EMAIL_VERIFIED_LABEL = 'Email (verified)';
export const UNIVERSITY_EMAIL_NOT_VERIFIED_LABEL = 'Email (not verified)';

export const ALLOWED_UPCOMING_STINT_STATUSES = [
  STINT_STATUS.ACCEPTED,
  STINT_STATUS.CHECKED_IN,
  STINT_STATUS.COMPLETED_IN_REVIEW,
];
